<template>
  <paginated-table
    ref="paginatedTable"
    :items="items"
    :headers="headers"
    :loading="loading"
    :pullFunction="fetchData"
    :pagination.sync="pagination"
  >
    <template #items="props">
      <td>{{ props.item.pattern }}</td>
      <td>{{ props.item.description }}</td>
      <td>{{ props.item.type }}</td>
      <td style="padding-top: 14px">
        <v-checkbox v-model="props.item.is_active" color="accent" @click.stop="togglePattern(props.item)" />
      </td>
      <td>{{ props.item.max_attempts }}</td>
      <td>{{ Math.floor(props.item.decay_seconds / 60) }}</td>
      <td>{{ formatDateTime(props.item.updated_at) }}</td>
      <td>
        <v-btn
          fab
          small
          color="secondary"
          style="display: inline"
        >
          <v-icon small @click="$emit('open-edit', props.item)"> edit </v-icon>
        </v-btn>

        <v-btn
          fab
          small
          color="secondary"
          style="display: inline"
        >
          <v-icon small @click="deleteDomain(props.item)"> delete </v-icon>
        </v-btn>
      </td>
    </template>
  </paginated-table>
</template>

<script>
import PaginatedTable from '@/components/PaginatedTable.vue'
import VueMixin from '@/components/VueMixin.vue'
import User from '../../../../../helpers/user'
import {
  deleteEmailDomain, editEmailDomain, getEmailDomain
} from '../../../../../api/banners'

export default {
  name: 'EmailDomainTable',
  components: { PaginatedTable },
  mixins: [VueMixin],
  data () {
    return {
      page: 1,
      pagination: {
        sortBy: 'id',
        descending: true
      },
      loading: true,
      headers: [
        {
          text: 'Паттерн', value: 'pattern', sortable: false
        },
        {
          text: 'Описание', value: 'description', sortable: false
        },
        {
          text: 'Тип', value: 'type', sortable: false
        },
        {
          text: 'Вкл / выкл', value: 'is_active', sortable: false
        },
        {
          text: 'Попытки', value: 'max_attempts', sortable: false
        },
        {
          text: 'Время на попытку (мин)', value: 'decay_seconds', sortable: false
        },
        {
          text: 'Обновлён', value: 'updated_at', sortable: true
        },
        {
          text: 'Действие', value: 'action', sortable: false
        }
      ],
      items: []
    }
  },
  computed: {
    User () {
      return User
    }
  },
  watch: {
    pagination: {
      handler () {
        this.fetchData(1)
      },
      deep: true
    }
  },
  mounted () {
    this.$root.$on('update-domain-table', () => this.fetchData(1))
  },
  beforeDestroy () {
    this.$root.$off('update-domain-table', () => this.fetchData(1))
  },
  methods: {
    fetchData (page) {
      this.loading = true
      this.page = page
      let sortParam = 'created_at:desc'
      if (this.pagination.sortBy) {
        const sortOrder = this.pagination.descending ? 'desc' : 'asc'
        sortParam = `${this.pagination.sortBy}:${sortOrder}`
      }

      getEmailDomain({
        limit: 26,
        offset: (page - 1) * 25,
        sort: sortParam
      }).then(response => {
        this.items = response.data
        this.loading = false
      })
    },
    deleteDomain (item) {
      deleteEmailDomain(item.id).then(() => this.fetchData(1))
    },
    togglePattern (item) {
      editEmailDomain(item.id, { is_active: !item.is_active }).then(() => this.fetchData(1))
    }
  }
}
</script>
